<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Reporte Gestion Ventas</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Gestion_01_ventas</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          reporte de gestion de ventas
        </b-col>
      </b-row>

      <div class="mt-2 col-md-12"></div>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(generar)">
          <b-row>
            <b-col>
              <b-row>

                <b-col cols="4">
                  <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de inicio:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha inicio"
                                         :max="new Date()"
                                         @input="fechaMaxima($event)"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="4">
                  <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de fin:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha fin"
                                         v-model="filtro.fechaFin"
                                         :max="filtro.fechaInicio.addDays(diasMaximoMes) > new Date() ? new Date(): filtro.fechaInicio.addDays(diasMaximoMes)"
                                         :min="filtro.fechaInicio"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="4">
                  <validation-provider name="clinica" :rules="{ required: true }" v-slot="validationContext">
                    <label>Clínica:<validacion/></label>
                    <b-container>
                      <b-row style="width: 100%">
                        <b-col cols="11">
                          <v-select style="width: 100%" :clearable="false" :options="listaClinicas"
                                    v-model="filtro.clinica"
                                    :reduce="(variable) => variable.idClinica"
                                    label="nombreClinica" placeholder="Selecciona una clínica" multiple>
                            <span slot="no-options">No hay clínicas disponibles</span>
                          </v-select>
                        </b-col>
                        <b-col cols="1">
                          <b-button
                              class="ml-1"
                              variant="outline-primary"
                              v-b-tooltip.hover
                              title="Seleccionar Todos"
                              @click="seleccionarTodasClinicas()">
                            <b-icon icon="check2-all"></b-icon>
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-container>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

              </b-row>
              <b-row>
                <b-col></b-col>
                <b-col></b-col>
                <b-col class="text-right">
                  <b-button
                      variant="outline-primary"
                      :disabled="loader"
                      @click="obtenerDatos()"
                  >
                    <span v-if="!loader">Buscar</span>
                    <span v-else>
                  <b-spinner small></b-spinner>
                  Buscando...
                </span>
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>

      <b-col cols="12">
        <download-excel
            v-if="datosTabla.length > 0 && $localStorageService.can('BT_01_excel_Rep_ventas')"
            class="btn btn-primary"
            :data="datosTabla"
            :fields="fieldsExcel"
            worksheet="GestionVentas"
            name="Reporte de gestion de ventas.xls"
        >
          Generar Excel
          <em class="fa fa-file-excel-o"></em>
        </download-excel>
      </b-col>
      <div class="mt-2 col-md-12"></div>

      <b-row>
        <b-col cols="12">
          <b-table
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive
              class="parrafos">
            <template v-slot:cell(valorPtiAceptado)="row">
              {{ row.item.valorPtiAceptado | monedaEntero }}
            </template>
            <template v-slot:cell(valorTxAceptado)="row">
              {{ row.item.valorTxAceptado | monedaEntero }}
            </template>
            <template v-slot:cell(ingreso)="row">
              {{ row.item.ingreso | monedaEntero }}
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla!==undefined && datosTabla.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tabla"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
import Header from "../../../components/Header";

export default {
  components: {
    Header
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loader: false,
      datosTabla: [],
      fields: [],
      paginaActual: 0,

      filtro: {
        fechaInicio: new Date(),
        fechaFin: null,
        clinica: null
      },
     fieldsExcel: {
        "Supervisor": "supervidor",
        "Clínica": "clinica",
        "Id Embajador": "idEmbajador",
        "Nombre Embajador": "embajador",
        "Puesto": "puesto",
        "Prospectos": "prospectos",
        "Valor PTI Aceptado ($)": "valorPtiAceptado",
        "PX Aceptaron": "pxAceptaron",
        "Valor TX Aceptados ($)": "valorTxAceptado",
        "Px Pagaron": "pxPagaron",
        "Ingreso ($)": "ingreso",
        "Entrega M2 minutos": "entregaM2Minutos"
      },
      listaClinicas: [],
      hoy: new Date(),
      diasMaximoMes: null
    }
  },
  mounted() {
    this.fields = [
      {key: "supervidor", label: "Supervisor", sortable: true},
      {key: "clinica", label: "Clinica", sortable: true},
      {key: "idEmbajador", label: "Id Embajador", sortable: true},
      {key: "embajador", label: "Nombre Embajador", sortable: true},
      {key: "puesto", label: "Puesto", sortable: true},
      {key: "prospectos", label: "Prospectos", sortable: true},
      {key: "valorPtiAceptado", label: "Valor PTI Aceptado ($)", sortable: true},
      {key: "pxAceptaron", label: "PX Aceptaron", sortable: true},
      {key: "valorTxAceptado", label: "Valor TX Aceptados ($)", sortable: true},
      {key: "pxPagaron", label: "Px Pagaron", sortable: true},
      {key: "ingreso", label: "Ingreso ($)", sortable: true},
      {key: "entregaM2Minutos", label: "Entrega M2 minutos", sortable: true}
      //{key: "aceptadosMes", label: "Aceptados al Mes", sortable: true},
      //{key: "aceptacion", label: "Aceptacion $", sortable: true},
      //{key: "efectividad", label: "Efectividad $", sortable: true},
       ];
    this.llenarClinicas();
      },
  methods: {
    llenarClinicas() {
      this.listaClinicas = this.$localStorageService.getClinicas();
    },
    seleccionarTodasClinicas() {
      this.filtro.clinica = this.listaClinicas;
    },
    fechaMaxima(event){
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = new Date(event);
      this.filtro.fechaFin = null;
      
    },
    obtenerDatos() {
      let fi = new Date(this.filtro.fechaInicio).addDays(1);
      fi.setHours(0,0,0,0)
      let ff = new Date(this.filtro.fechaFin).addDays(1);
      ff.setHours(23, 59, 59, 999)
      let fechaActual = this.$moment(fi);
      let fechaF = this.$moment(ff);
      let fechaInicial = fechaActual.format("YYYY-MM-DD[T]HH:mm:ssZ");
      let fechaFinal = fechaF.format("YYYY-MM-DD[T]HH:mm:ssZ");

      if(this.filtro.clinica.length === this.listaClinicas.length){
        let lista = []
        this.filtro.clinica.forEach(e=>{
          lista.push(e.idClinica);
        });
        this.filtro.clinica = lista;
      }
      this.loader = true;
      this.datosTabla = [];
      const filtro = {
        "fechaInicio": fechaInicial,
        "fechaFin": fechaFinal,
        "clinica": this.filtro.clinica
      };
      this.$http
          .post(this.$api + 'reportes/gestionVentas', filtro)
          .then(respuesta => {
        if (respuesta.data.data) {

          if (respuesta.data.data !== undefined) {
            this.datosTabla = respuesta.data.data;
            this.datosTabla.forEach((value,index) => {
              this.datosTabla[index]["aceptacion"]=1;
            });
          }
        }
      }).finally(() => {
        this.loader = false;
        this.paginaActual = 0;
      })


    }

  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>

</style>